import ApiBaseModel from "@/common/models/ApiBaseModel";

export default class PreferenceDispenserColorsModel extends ApiBaseModel {
    colorMainButtonForeground: string = "";
    colorMainButtonBackground: string = "";
    colorMainButtonBorder: string = "";
    colorNumericButtonForeground: string = "";
    colorNumericButtonBackground: string = "";
    colorNumericButtonBorder: string = "";
    colorCancelButtonForeground: string = "";
    colorCancelButtonBackground: string = "";
    colorCancelButtonBorder: string = "";
    colorClearButtonForeground: string = "";
    colorClearButtonBackground: string = "";
    colorClearButtonBorder: string = "";
    colorEnterButtonForeground: string = "";
    colorEnterButtonBackground: string = "";
    colorEnterButtonBorder: string = "";
    colorReloadButtonForeground: string = "";
    colorReloadButtonBackground: string = "";
    colorReloadButtonBorder: string = "";
    colorBayButtonForeground: string = "";
    colorBayButtonBackground: string = "";
    colorBayButtonBorder: string = "";
    colorBayBallsForeground: string = "";
    colorBaySubtextForeground: string = "";
    colorBaySubtextBackground: string = "";

    static from(json: string): PreferenceDispenserColorsModel {
        let model = Object.assign(new PreferenceDispenserColorsModel(), json);
        return model;
    }
}
